import css from "../css/top-display.module.css";

const TopDisplay = (props: any) => {
  const subTitle = props.subTitle;
  const title = props.title;
  const Btn: any = props.Btn;
  
  return (
    <div className={css.container}>
      <div>{subTitle}</div>
      <div>
        <div>{title}</div>
        {Btn ? Btn : ""}
      </div>
    </div>
  );
};

export default TopDisplay;
